import {
  DrawOrderStatus,
  DrawStatus,
  GameType,
  OrderStatus,
  PaymentMethod,
  PaymentStatus,
  PurchasingAction,
  SubscriptionStatus,
  TicketStatus,
} from '@daymade/common-lib/dbEnums';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { YourSubscription } from 'components/confirmation2026/YourSubscription';
import { useState } from 'react';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';

const ACTIVE_SUBSCRIPTION = {
  order: {
    id: '914a57dd-6153-4c42-89cb-9962b6d6be48',
    createdAt: new Date('2026-03-27T13:38:38.797Z'),
    status: OrderStatus.COMPLETED,
    playerId: '44771057-acf4-4bf7-9524-c4d112e44732',
    isSubscription: true,
    totalFiatAmount: 1854,
    tokenAmount: 0,
    paymentMethod: PaymentMethod.ADYEN,
    subscriptionId: '014cdef0-3cee-43d9-b850-924f7d3cac43',
  },
  drawOrder: {
    id: 'a61b3d8d-137c-4706-bd2c-ef7f3dee9bfa',
    status: DrawOrderStatus.ACTIVE,
    orderId: '914a57dd-6153-4c42-89cb-9962b6d6be48',
    playerId: '44771057-acf4-4bf7-9524-c4d112e44732',
    firstDrawId: 9791,
    drawTypeCode: 'DAYMADEDRAW',
    entries: [
      {
        type: GameType.LOTTERY as typeof GameType.LOTTERY,
        main: [6, 18, 23, 52],
        bonus: [2],
      },
      {
        type: GameType.LOTTERY as typeof GameType.LOTTERY,
        main: [2, 24, 31, 51],
        bonus: [9],
      },
      {
        type: GameType.LOTTERY as typeof GameType.LOTTERY,
        main: [2, 16, 17, 20],
        bonus: [2],
      },
      {
        type: GameType.LOTTERY as typeof GameType.LOTTERY,
        main: [7, 49, 51, 54],
        bonus: [5],
      },
    ],
    price: 2000,
    createdAt: new Date('2026-03-27T13:38:38.797Z'),
  },
  subscription: {
    id: '014cdef0-3cee-43d9-b850-924f7d3cac43',
    status: SubscriptionStatus.ACTIVE,
    playerId: '44771057-acf4-4bf7-9524-c4d112e44732',
    orderId: '914a57dd-6153-4c42-89cb-9962b6d6be48',
    paymentDow: 3,
    failedAt: null,
    version: 0,
    createdAt: new Date('2026-03-27T13:38:51.196Z'),
    nextPaymentDate: new Date('2026-04-08T01:00:00.000Z'),
    cancelledAt: null,
    snoozedUntil: null,
  },
  drawSchedulePlans: [
    {
      drawSchedule: {
        id: 1,
        templateName: 'Weekly Tuesday Draw',
        description: null,
        code: 'TUESDAY',
        drawTypeCode: 'DAYMADEDRAW',
        prizeStructureId: 1,
      },
      drawTypePlan: {
        id: 1,
        drawTypeCode: 'DAYMADEDRAW',
        code: 'PREMIUM',
        subcode: 'BASE',
        name: 'Premium Tickets',
        desc: null,
        priceVersion: 0,
        priceTable: {
          '0': {
            GBP: {
              '1': 295,
              '2': 275,
              '3': 260,
              '4': 250,
            },
            TOKEN: {
              '1': 6,
            },
          },
        },
      },
    },
    {
      drawSchedule: {
        id: 2,
        templateName: 'Weekly Friday Draw',
        description: null,
        code: 'FRIDAY',
        drawTypeCode: 'DAYMADEDRAW',
        prizeStructureId: 1,
      },
      drawTypePlan: {
        id: 1,
        drawTypeCode: 'DAYMADEDRAW',
        code: 'PREMIUM',
        subcode: 'BASE',
        name: 'Premium Tickets',
        desc: null,
        priceVersion: 0,
        priceTable: {
          '0': {
            GBP: {
              '1': 295,
              '2': 275,
              '3': 260,
              '4': 250,
            },
            TOKEN: {
              '1': 6,
            },
          },
        },
      },
    },
  ],
  drawType: {
    code: 'DAYMADEDRAW',
    name: 'Daymade Main Draw',
    gameType: GameType.LOTTERY as typeof GameType.LOTTERY,
    group: 'DAYMADEDRAW',
    numberSetup: {
      type: 'LOTTERY' as typeof GameType.LOTTERY,
      main: [55, 55, 55, 55],
      bonus: [10],
    },
  },
};

const activeTickets = [
  {
    ticket: {
      id: 'ecaf0c81-1f3e-42bb-bc98-356181381993',
      status: TicketStatus.PLACED,
      playerId: '44771057-acf4-4bf7-9524-c4d112e44732',
      drawOrderId: 'a61b3d8d-137c-4706-bd2c-ef7f3dee9bfa',
      drawId: 9838,
      drawTypePlanId: 1,
      cost: 1000,
      paid: 927,
      createdAt: new Date('2026-03-27T13:38:51.196Z'),
    },
    entries: [
      {
        type: 'LOTTERY' as typeof GameType.LOTTERY,
        main: [6, 18, 23, 52],
        bonus: [2],
      },
      {
        type: 'LOTTERY' as typeof GameType.LOTTERY,
        main: [2, 24, 31, 51],
        bonus: [9],
      },
      {
        type: 'LOTTERY' as typeof GameType.LOTTERY,
        main: [2, 16, 17, 20],
        bonus: [2],
      },
      {
        type: 'LOTTERY' as typeof GameType.LOTTERY,
        main: [7, 49, 51, 54],
        bonus: [5],
      },
    ],
    draw: {
      id: 9838,
      name: 'Weekly Tuesday Draw',
      description: null,
      status: DrawStatus.SCHEDULED,
      drawDate: new Date('2026-04-07T16:00:00.000Z'),
      pendingResult: null,
      result: null,
    },
    drawSchedule: {
      id: 1,
      templateName: 'Weekly Tuesday Draw',
      description: null,
      code: 'TUESDAY',
      drawTypeCode: 'DAYMADEDRAW',
      prizeStructureId: 1,
    },
    drawType: {
      code: 'DAYMADEDRAW',
      name: 'Daymade Main Draw',
      gameType: 'LOTTERY' as typeof GameType.LOTTERY,
      group: 'DAYMADEDRAW',
      numberSetup: {
        type: 'LOTTERY' as typeof GameType.LOTTERY,
        main: [55, 55, 55, 55].slice(),
        bonus: [10].slice(),
      },
    },
    drawTypePlan: {
      id: 1,
      drawTypeCode: 'DAYMADEDRAW',
      code: 'PREMIUM',
      subcode: 'BASE',
      name: 'Premium Tickets',
      desc: null,
      priceVersion: 0,
      priceTable: {
        '0': {
          GBP: {
            '1': 295,
            '2': 275,
            '3': 260,
            '4': 250,
          },
          TOKEN: {
            '1': 6,
          },
        },
      },
    },
    paymentRequest: {
      id: '3b7d2ffa-8416-42c4-98aa-809907844296',
      createdAt: new Date('2026-03-27T13:38:38.797Z'),
      status: PaymentStatus.APPROVED,
      purchasingAction: PurchasingAction.SUBSCRIPTION_INITIAL,
      totalFiatAmount: 2000,
      balanceAmount: 0,
      giftCardAmount: 0,
      promoAmount: 0,
      tokenAmount: 0,
      discountAmount: 146,
      paymentMethodAmount: 1854,
    },
    subscription: {
      id: '014cdef0-3cee-43d9-b850-924f7d3cac43',
      status: SubscriptionStatus.ACTIVE,
      playerId: '44771057-acf4-4bf7-9524-c4d112e44732',
      orderId: '914a57dd-6153-4c42-89cb-9962b6d6be48',
      paymentDow: 3,
      failedAt: null,
      version: 0,
      createdAt: new Date('2026-03-27T13:38:51.196Z'),
      nextPaymentDate: new Date('2026-04-08T01:00:00.000Z'),
      cancelledAt: null,
      snoozedUntil: null,
    },
  },
] as const;

const ComponentPreview = () => {
  const [expanded, setExpanded] = useState(false);
  return (
    <AboutUsModule background="grey">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">Your Subscription </h3>
        <p>
          <>
            The "Your Subscription" component, as used on the confirmation page.
          </>
        </p>
        <div style={{ width: '50%', padding: 16, margin: 'auto' }}>
          <YourSubscription
            expanded={expanded}
            onClick={() => setExpanded(!expanded)}
            activeSubscription={ACTIVE_SUBSCRIPTION}
            activeTickets={activeTickets.map((ticket) => ({
              ...ticket,
              entries: ticket.entries
                ? ticket.entries.map((e) => ({
                    ...e,
                    type:
                      e.type === 'LOTTERY'
                        ? (GameType.LOTTERY as typeof GameType.LOTTERY)
                        : e.type,
                    main: e.main ? [...e.main] : [],
                    bonus: e.bonus ? [...e.bonus] : [],
                  }))
                : [],
            }))}
          />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Your Subscription',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
